import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import {
    CUSTOMER_GROUP_LABELS, GROUP_ID_EMPLOYEE, GROUP_ID_PRO, GROUP_ID_STUDENT
} from 'Route/MyAccount/MyAccount.config';

import './RestrictedContentOverlay.style';

/** @namespace PeggysagePwa/Component/RestrictedContentOverlay/Component */
export class RestrictedContentOverlayComponent extends PureComponent {
    static propTypes = {
        allowedCustomerGroupIds: PropTypes.arrayOf(PropTypes.number).isRequired,
        userGroupId: PropTypes.number
    };

    static defaultProps = {
        userGroupId: 0
    };

    renderRestrictedContentLoggedIn() {
        const { allowedCustomerGroupIds, userGroupId } = this.props;

        if (allowedCustomerGroupIds.includes(1) && userGroupId !== 1) {
            return (
                <div
                  block="RestrictedContentOverlay"
                  elem="Content"
                  title={ `${__('Réservé aux')} ${__('utilisateurs connectés')}` }
                />
            );
        }

        return null;
    }

    renderRestrictedContentPro() {
        const { allowedCustomerGroupIds, userGroupId } = this.props;

        if ((allowedCustomerGroupIds.includes(GROUP_ID_PRO) && userGroupId !== GROUP_ID_PRO) || (allowedCustomerGroupIds.includes(GROUP_ID_EMPLOYEE) && userGroupId !== GROUP_ID_PRO)) {
            return (
                <div
                  block="RestrictedContentOverlay"
                  elem="Content"
                  mods={ { pro: true } }
                  title={ `${__('Réservé aux')} ${CUSTOMER_GROUP_LABELS[GROUP_ID_PRO].plural.toLowerCase()}` }
                >
                    <span>
                        <strong>{ CUSTOMER_GROUP_LABELS[GROUP_ID_PRO].singular }</strong>
                    </span>
                </div>
            );
        }

        return null;
    }

    renderRestrictedContentStudent() {
        const { allowedCustomerGroupIds, userGroupId } = this.props;

        if (allowedCustomerGroupIds.includes(GROUP_ID_STUDENT) && userGroupId !== GROUP_ID_STUDENT) {
            return (
                <div
                  block="RestrictedContentOverlay"
                  elem="Content"
                  mods={ { student: true } }
                  title={ `${__('Réservé aux')} ${CUSTOMER_GROUP_LABELS[GROUP_ID_STUDENT].plural.toLowerCase()}` }
                >
                    <span>
                        <strong>{ CUSTOMER_GROUP_LABELS[GROUP_ID_STUDENT].singular }</strong>
                    </span>
                </div>
            );
        }

        return null;
    }

    render() {
        const { allowedCustomerGroupIds, userGroupId } = this.props;

        if (!allowedCustomerGroupIds.length
            || allowedCustomerGroupIds.includes(0)
            // || (allowedCustomerGroupIds.length === 1 && allowedCustomerGroupIds.includes(1) && userGroupId >= 1)
            || allowedCustomerGroupIds.includes(userGroupId)) {
            return null;
        }

        return (
            <div block="RestrictedContentOverlay">
                { this.renderRestrictedContentLoggedIn() }
                { this.renderRestrictedContentPro() }
                { this.renderRestrictedContentStudent() }
            </div>
        );
    }
}

export default RestrictedContentOverlayComponent;
